import { INetworkClient } from "@/domain/repositories/NetworkClient";
import container from "../../infrastructure";
import { AuthenticatorUsecase } from "./Auth/authenticator.usecase";
import { IAuthenticator } from "@/domain/repositories/Auth";
import { ISessionManager } from "@/domain/repositories/Session";
import { ITokenDecoder } from "@/domain/repositories/DecodeToken";
import { SessionUseCase } from "./Auth/session.usecase";
import { FormAnswerUsecase } from "./Form/answer.usecase";
import { CertificateUseCase } from "./Form/certificate.usecase";

class UseCaseFactory {
  azureAuthenticator = container.resolve<IAuthenticator>("AzureAuthenticator");
  basicAuthenticator = container.resolve<IAuthenticator>("BasicAuthenticator");

  sessionManager = container.resolve<ISessionManager>("SessionManager");

  jwtDecoder = container.resolve<ITokenDecoder>("JWTDecoder");

  networkClient = container.resolve<INetworkClient>("NetworkClient");

  // Auth
  makeAzureAuhenticatorUseCase() {
    return new AuthenticatorUsecase(
      this.azureAuthenticator,
      this.networkClient,
      this.jwtDecoder
    );
  }

  makeBasicAuthenticatorUseCase() {
    return new AuthenticatorUsecase(
      this.basicAuthenticator,
      this.networkClient,
      this.jwtDecoder
    );
  }

  makeSessionUseCase() {
    return new SessionUseCase(this.sessionManager, this.jwtDecoder);
  }

  // Form
  makeFormAnswerUseCase() {
    return new FormAnswerUsecase(this.networkClient);
  }

  // Certificate
  makeUserCertificatesUseCase() {
    return new CertificateUseCase(this.networkClient);
  }
}

const useCaseFactory = new UseCaseFactory();
export default useCaseFactory;
